import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { Button, ButtonGroup, useToast } from '@chakra-ui/react'
import { format, addDays } from 'date-fns'
import { graphql } from '@/__generated__/gql'
import { Drawer } from '@/components/drawer'
import { CreateInvoiceForm, FormValues } from './components/create-invoice-form'

const createInvoiceDocument = graphql(`
  mutation CreateInvoice($input: InvoiceInput!) {
    createInvoice(input: $input) {
      message
      invoice {
        id
      }
    }
  }
`)

export function NewInvoiceRoute() {
  const navigate = useNavigate()
  const toast = useToast()
  const onClose = useCallback(() => navigate('..'), [navigate])

  const [createInvoice, { loading: isSubmitting }] = useMutation(
    createInvoiceDocument,
    {
      refetchQueries: ['Invoices'],
      onCompleted(data) {
        toast({
          status: 'success',
          title: data.createInvoice.message,
          isClosable: true,
        })
        navigate(`../${data.createInvoice.invoice.id}`)
      },
      onError(error) {
        toast({
          status: 'error',
          title: error.message,
          isClosable: true,
        })
      },
    }
  )

  const onSubmit = useCallback(
    async (input: FormValues) => {
      await createInvoice({ variables: { input } })
    },
    [createInvoice]
  )

  return (
    <Drawer
      title="Ny faktura"
      onClose={onClose}
      footer={
        <ButtonGroup>
          <Button onClick={onClose}>Avbryt</Button>
          <Button
            form="invoice-form"
            type="submit"
            colorScheme="blue"
            isLoading={isSubmitting}
          >
            Opprett faktura
          </Button>
        </ButtonGroup>
      }
    >
      <CreateInvoiceForm
        onSubmit={onSubmit}
        defaultValues={{
          issueDate: format(new Date(), 'Y-MM-dd'),
          dueDate: format(addDays(new Date(), 14), 'Y-MM-dd'),
        }}
      />
    </Drawer>
  )
}
